import React, { useState } from 'react';
import TTURenderer from '@layout/TTURenderer';
import HeroCard from './HeroCard';
import StatsCards from './StatsCards';
import FeatureCardsSection from './FeatureCards';
import HelpSection from './HelpSection';
import FAQSection from './FAQSection';
import TestSeriesSection from './TestSeriesSection';
import CenterSelectionModal from './CenterSelectionModal';
import FindNearestTestCenterSection from './FindNearestTestCenterSection';
import { useTestSeriesData } from './useTestSeriesData';

const TestSeriesPageContent = () => {
  const [showTTU, setShowTTU] = useState(false);
  const { data } = useTestSeriesData();
  const [backButton, setBackButton] = useState({ value: false, fn: () => {} });
  const handleBackPress = () => backButton.fn();
  const onCloseTTU = () => {
    setShowTTU(false);
  };

  if (!data) return null;
  return (
    <div
      style={{
        background: 'var(--color-base-1)'
      }}
    >
      <TTURenderer
        onCloseTTU={onCloseTTU}
        showTTU={showTTU}
        backButton={backButton}
        setBackButton={setBackButton}
        handleBackPress={handleBackPress}
        ttuTriggerSource="Test Series"
        ttuOptions={undefined}
      />
      <CenterSelectionModal />
      <HeroCard />
      <StatsCards />
      <FeatureCardsSection />
      <TestSeriesSection />
      <FindNearestTestCenterSection />
      <HelpSection setShowTTU={setShowTTU} />
      <FAQSection />
    </div>
  );
};

export default TestSeriesPageContent;
